module.exports = __webpack_public_path__ + "light.030aecac.png";